import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment-timezone';


class Timezone extends React.Component {

	handleClick(event) {
	}

	constructor(props) {
		super(props);
		this.state = {time: moment().tz(this.props.state.timezone??moment.tz.guess()).format("h:mm A")};
	}

	componentDidMount() {
		setInterval( ()=> {
			this.setState({time: moment().tz(this.props.state.timezone??moment.tz.guess()).format("h:mm A")})
		},1000);
	}

	render () {
		var now = this.state.time
		return (
			<div className="dropdown d-inline mr-1">
			<button className="btn btn-card dropdown-toggle no-arrow text-white pb-0 pt-0" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
			{now}
			</button>
			<div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
				<a className="dropdown-item" id="Open" data-value="America/Adak" href="/set-bg-timezone/Hawaii">Hawaii</a>
				<a className="dropdown-item" id="Open" data-value="Pacific/Honolulu" href="/set-bg-timezone/Hawaii2">Hawaii no DST</a>
				<a className="dropdown-item" id="Open" data-value="America/Anchorage" href="/set-bg-timezone/Alaska">Alaska</a>
				<a className="dropdown-item" id="Open" data-value="America/Los_Angeles" href="/set-bg-timezone/Pacific">Pacific</a>
				<a className="dropdown-item" id="Open" data-value="America/Denver" href="/set-bg-timezone/Mountain">Mountain</a>
				<a className="dropdown-item" id="Open" data-value="America/Phoenix" href="/set-bg-timezone/Mountain2">Mountain no DST</a>
				<a className="dropdown-item" id="Open" data-value="America/Chicago" href="/set-bg-timezone/Central">Central</a>
				<a className="dropdown-item" id="Open" data-value="America/New_York" href="/set-bg-timezone/Eastern">Eastern</a>
			</div>
			<div className="anim-pulse timezone-badge bg-danger align-items-center justify-content-center d-flex rounded-circle">
				<i className="fas fa-exclamation text-white"></i>
			</div>
			</div>
				);
	}
}

function mapStateToProps(state) {
	return { state:state }
}

export default connect(mapStateToProps)(Timezone)
